module.exports = __webpack_public_path__ + "img/Text_Rank.ce976355.png";